export default {
  SpecialOffersCard__ARIA_LABEL_CURRENT_PAGE: "The current page is",
  SpecialOffersCard__ARIA_LABEL_FOCUS_CHANGE_NEXT:
    "First page; focus will move to the next page button.",
  SpecialOffersCard__ARIA_LABEL_FOCUS_CHANGE_PREVIOUS:
    "Final page; focus will move to the previous page button.",
  SpecialOffersCard__ARIA_LABEL_NEXT: "Press this button to display the next page of items.",
  SpecialOffersCard__ARIA_LABEL_PAGE_COUNT: "Total number of pages",
  SpecialOffersCard__ARIA_LABEL_PREVIOUS:
    "Press this button to display the previous page of items.",
};
